<template>
<div class="chapter">
<div class="inner_page">
<div class="section level2" id="by-the-seaside">
<h2>By the Seaside</h2>
<p>We stood along the shore,</p>
<p>Savouring the lingering scent of salt water</p>
<p>As gentle breezes floated by.</p>
<p>You tucked your hand beneath my chin</p>
<p>And leaned in for a tender kiss.</p>
<br/>
<p>You tasted of Marlboro cigarettes.</p>
<p>I smiled in spite of myself,</p>
<p>Feeling as if I were back in high school,</p>
<p>Skipping class to kiss a boy on the beach of Arcachon.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?1076d989